<div class="heatmap-card">
    <div class="heatmap-header">
        <h3 class="chart-title">{{ 'pages.collections.analytics.heatmap_title' | translate }}</h3>
        <div class="category-tabs" *ngIf="areas.length > 0">
            <button *ngFor="let tab of areaTabs"
                    class="category-tab"
                    [class.active]="selectedAreaId === tab.id"
                    (click)="onAreaFilter(tab.id)">
                {{ tab.name }}
            </button>
        </div>
    </div>
    <div class="heatmap-container">
        <div id="collects-analytics-heatmap" class="map"></div>
        <div *ngIf="filteredPoints.length === 0" class="no-data-overlay">
            {{ 'pages.collections.analytics.no_data' | translate }}
        </div>
    </div>
    <div class="heatmap-footer">
        <span class="point-count">{{ filteredPoints.length }} {{ 'pages.collections.analytics.heatmap_points' | translate }}</span>
        <span class="coverage" *ngIf="coveragePercent !== undefined">
            &mdash; {{ 'pages.collections.analytics.heatmap_coverage' | translate: { percent: coveragePercent } }}
        </span>
    </div>
</div>
